import React from 'react';
import { Box, FormControl, FormHelperText, MenuItem, Select, Typography } from '@mui/material';

const CustomDropdownMenu = ({ options, selectedOption, handleOptionChange, error ,menulabel="Select Option"}) => {
  return (
    <Box sx={{ width: "100%" }}>
      <FormControl fullWidth error={!!error}>
        <Select
          value={selectedOption}
          onChange={handleOptionChange}
          displayEmpty
          inputProps={{ 'aria-label': 'PO Option' }}
          size='small'
        >
          <MenuItem value="" disabled>
            <Typography color="textSecondary">
            {menulabel}
            </Typography>
          </MenuItem>

          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography>{option.label}</Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>

        {error && (
          <FormHelperText>{error}</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};

export default CustomDropdownMenu;


///////////////////////USES////////////////////////


// import React, { useState } from 'react';
// import CustomDropdown from './CustomDropdown'; // Adjust the import path as necessary

// const ExampleUsage = () => {
//   const [selectedOption, setSelectedOption] = useState('');
//   const [error, setError] = useState('');

//   const options = [
//     { value: '0', label: 'Full Indent PO' },
//     { value: '1', label: 'Partial Indent PO' },
//     { value: '2', label: 'Final PO of Partial Indent' }
//   ];

//   const handleOptionChange = (event) => {
//     setSelectedOption(event.target.value);
//   };

//   return (
//     <CustomDropdown
//       options={options}
//       selectedOption={selectedOption}
//       handleOptionChange={handleOptionChange}
//       error={error}
//     />
//   );
// };

// export default ExampleUsage;
